import React from "react";
import { t } from "src/shared/locales/i18n";
import { DivLiveTag } from "../style/LiveTag.style";

const LiveTag = () => {
  return <DivLiveTag className="akn-live-tag">{t("live")}</DivLiveTag>;
};

export default LiveTag;
